import { useQuery } from '@tanstack/react-query';
import { getIntervalFromDateRange } from 'pages/admin/CostDashboard/helper';
import { bff } from 'shared/api';
import { CostSummaryReply, CostSummaryV2Request } from 'shared/types/protoc-gen/bffbillsystem';
import { QUERY_KEYS } from 'shared/types/react-query';

export type IUseGetCostSummary = Omit<CostSummaryV2Request, 'namespace' | 'period'> &
  Partial<Pick<CostSummaryV2Request, 'namespace' | 'period' | 'area'>>;

const useGetCostSummary = (params: IUseGetCostSummary) => {
  const kind = params.kind !== 'ALL' ? params.kind : '';
  const type = params.type !== 'ALL' ? params.type : '';

  const payload: IUseGetCostSummary = {
    ...params,
    period: getIntervalFromDateRange(params.startDate, params.endDate),
    kind,
    type,
  };

  return useQuery<CostSummaryReply>({
    queryKey: [
      QUERY_KEYS.ADMIN_COST_SUMMARY,
      params.startDate,
      params.endDate,
      params.area,
      kind,
      type,
    ],
    queryFn: async () => {
      const res = await bff.get<CostSummaryReply>('/bff/cost/summary_v2', { params: payload });

      return res.data;
    },
  });
};

export default useGetCostSummary;
